
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_24182_91687)","stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M22.499 38.712c9.231 0 16.714-7.484 16.714-16.715 0-9.23-7.483-16.714-16.714-16.714-9.231 0-16.714 7.483-16.714 16.714 0 9.232 7.483 16.715 16.714 16.715z"}}),_c('path',{attrs:{"d":"M23.475 30.07L28 16.497l-13.575 4.525 5.656 3.394 3.394 5.656z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_24182_91687"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(4.5 4)","d":"M0 0h36v36H0z"}})])])])
          )
        }
      }
    